import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";

const HERO_IMAGE = "/hero-magicprint.webp";

const TShirtBedrukkenWestland = () => (
  <PageLayout
    title="T-shirt bedrukken Westland"
    metaDescription="T-shirt bedrukken in het Westland. Magic Print levert en bezorgt gratis in de hele Westland regio. Professionele bedrukkingen tegen concurrerende prijzen."
    ogImage={HERO_IMAGE}
    hero={
      <PageHero image={HERO_IMAGE} alt="T-shirt bedrukken Westland" title="T-shirt bedrukken Westland" subtitle="Magic Print levert en bezorgt gratis in de hele Westland regio." />
    }
  >
    
    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      Heb je een bedrijf in het Westland en wil je dat jouw medewerkers in professionele bedrijfskleding lopen? Magic Print levert in het gehele Westland en wij bezorgen gratis in de hele Westland regio!
    </p>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Professionele bedrukking in het Westland</h2>
      <p className="text-muted-foreground mb-4">
        Wij werken met de beste machines en materialen wat betekent dat wij goed textiel met professionele bedrukkingen leveren. Dit alles tegen zéér concurrerende prijzen. Alle artikelen die wij leveren kunt u vinden op onze website onder "producten" waarop meer dan 70 merken staan, alle met hun uitgebreide collecties.
      </p>
      <p className="text-muted-foreground">
        Wij leveren de beste kwaliteit tegen de laagste prijs en zijn erg flexibel wat betreft het maken van afspraken – dat kan ook in de avonduren en in het weekend.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Voor iedereen in het Westland</h2>
      <p className="text-muted-foreground mb-4">
        Of het nu 10 of 10.000 t-shirts betreft of andere kleding, u bent meer dan welkom. Particulier of bedrijf, iedereen krijgt bij ons dezelfde service!
      </p>
      <p className="text-muted-foreground">
        Ook voor goed betaalbare werkkleding kun je bij Magic Print terecht: werkjassen, werkbroeken, werkschoenen, veiligheidsvestjes en nog vele andere producten kunnen wij voor u leveren en bedrukken of borduren met uw bedrijfslogo.
      </p>
    </section>
  </PageLayout>
);

export default TShirtBedrukkenWestland;
